import React from 'react';
import { FAQS, PRICING } from '../mock';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';

const FAQ = () => {
  return (
    <section id="faq" className="section bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
          {/* Pricing sidebar */}
          <aside className="lg:col-span-1">
            <span className="text-xs font-bold uppercase tracking-[0.25em] gold-text">Transparent pricing</span>
            <h2 className="mt-3 text-3xl md:text-4xl font-extrabold navy-text leading-tight">Cost per mile</h2>
            <p className="mt-3 text-[#4A5A72]">Rates vary by distance, season and vehicle type. These are general guidelines for planning.</p>

            <div className="mt-6 space-y-5">
              <div className="bg-[#F7F9FC] rounded-2xl p-5 border border-[#E5EAF2]">
                <h3 className="font-extrabold navy-text mb-3">Open trailer</h3>
                <ul className="space-y-2 text-sm">
                  {PRICING.open.map((p, i) => (
                    <li key={i} className="flex justify-between gap-3">
                      <span className="text-[#4A5A72]">{p.range}</span>
                      <span className="font-bold text-[#0A1628]">{p.price}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="bg-[#0A1628] rounded-2xl p-5 text-white">
                <h3 className="font-extrabold mb-3">Enclosed trailer</h3>
                <ul className="space-y-2 text-sm">
                  {PRICING.enclosed.map((p, i) => (
                    <li key={i} className="flex justify-between gap-3">
                      <span className="text-white/70">{p.range}</span>
                      <span className="font-bold text-[#D4A24C]">{p.price}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </aside>

          {/* FAQ */}
          <div className="lg:col-span-2">
            <span className="text-xs font-bold uppercase tracking-[0.25em] gold-text">FAQ</span>
            <h2 className="mt-3 text-3xl md:text-4xl font-extrabold navy-text leading-tight mb-6">Common questions, clear answers.</h2>
            <Accordion type="single" collapsible className="space-y-3" defaultValue="item-0">
              {FAQS.map((f, i) => (
                <AccordionItem key={i} value={`item-${i}`} className="border border-[#E5EAF2] rounded-xl px-5 bg-white">
                  <AccordionTrigger className="text-left font-bold text-[#0A1628] hover:no-underline py-5">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-[#4A5A72] pb-5">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
